import { Transition } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import { FunctionComponent } from 'react';
import './PageProgressIndicatorItem.scss';

export interface IPageProgressIndicatorItemProps {
  isHighlighted: boolean;
  isCurrent: boolean;
  label: string;
  animate: boolean;
  className?: string | object;
}

const PageProgressIndicatorItem: FunctionComponent<IPageProgressIndicatorItemProps> = (props) => {
  const { isHighlighted, isCurrent, label, animate, className } = props;

  const classes = classNames(
    {
      'current': isCurrent,
      'highlighted': isHighlighted,
      'page-progress-indicator-item': true,
    },
    className
  );

  const progressCircleClasses = classNames({
    'progress-circle': true,
    'animate': animate,
    'highlighted': isHighlighted,
  });

  return (
    <div className={classes}>
      <div className="progress-circle-shell">
        <Transition isOpen={isHighlighted} transitionName="fill-in" speedIn={1200} speedOut={400}>
          <div className={progressCircleClasses} />
        </Transition>
      </div>
      <h5>{label}</h5>
    </div>
  );
};

export default PageProgressIndicatorItem;
